import * as React from "react"
import { Form, Button, Col } from 'react-bootstrap'
import "../pages/index.css"
import image from "../images/logo_bv.png"

// markup
const IndexPage = () => {
  return (
    <main>
      <title>New Year Buenaventura 2022</title>
      <div class="page-width">
        <img src={image} class="logo-bv"/>
        <p class="subtitle">tiene el placer de invitarte al</p>
        <h1 class="title">NEW YEAR</h1>
        <h1 class="title">PARTY</h1>
        <p class="text">Para adquirir tu entrada:</p>
        <ul class="list-style">
          <li>1. Rellena el formulario y presiona "Enviar"</li>
          <li>2. Una vez enviado te aparecerá un botón para poder efectuar tu pago a través de Yappy</li>
          <li>3. Ya estas listo para darle la bienvenida al 2022</li>
        </ul>
        <div className="rsvp_form">
          <Form method="post" action="https://formspree.io/f/xnqwqrao" >
            <Col className="contactrow">
              <div class="flex">
                <input name="nombre" type="text" required placeholder="Nombre" className="placeholder mr-10" required/>
                <input name="apellido" type="text" required placeholder="Apellido" className="placeholder" required/>
              </div>
            </Col>
            <Col className="contactrow">
              <div class="flex">
                <input name="telefono" type="text" required placeholder="Número telefónico" className="placeholder mr-10" required/>
                <input name="cedula" type="text" placeholder="Cédula" className="placeholder" required/>
              </div>
            </Col>

            <Col className="contactrow">
              <div class="flex">
                <input name="email" type="email" required placeholder="Email" className="placeholder" required/>
              </div>
            </Col>

            <Col className="contactrow">
              <div class="flex">
                <input name="cada/residente" type="text" required placeholder="Casa/Residente*" className="placeholder mr-10" required/>
                <input name="codigo" type="text" placeholder="Código de acceso" className="placeholder" required/>
              </div>
            </Col>

            <p class="italic__">*Invitados poner casa quien los invito</p>

            <Col className="contactrow">
              <Button id="landing-link" type="submit" size="sm">ENVIAR</Button>
            </Col>
          </Form>
        </div>
      </div>
    </main>
  )
}

export default IndexPage
